import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import { Slide, ToastContainer, toast } from 'react-toastify';

const ToastWrap = () => (
	<ToastContainer
		position={toast.POSITION.TOP_RIGHT}
		autoClose={5000}
		hideProgressBar
		closeButton={false}
		transition={Slide}
		draggable={false}
		pauseOnFocusLoss={false}
		closeOnClick={false}
		className="toaster"
	/>
);

export default React.memo(ToastWrap);
